module.exports = __webpack_public_path__ + "media/images/VABBnation-67b3001f4f0ce85e513865d1d5e72000.png";